export const en = {
  brand: "OrderHub",
  linkHint: "If the button above doesn't work, copy and paste this link into your browser:",
};